var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"snackbar-container text-center"},[_c('v-snackbar',{attrs:{"color":"borderDark","timeout":"3000"},model:{value:(_vm.$store.state.showMessage),callback:function ($$v) {_vm.$set(_vm.$store.state, "showMessage", $$v)},expression:"$store.state.showMessage"}},[_vm._v(_vm._s(_vm.$store.state.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }